import { useDispatch, useSelector } from 'react-redux';
import { setKioskView } from 'src/actions';

// todo: rename useNyAffordableSettings
export const useKiosk = () => {
  const dispatch = useDispatch();
  const kioskMode = useSelector((store) => store.app.kioskMode);
  // todo: rename quickView or something like that
  const kioskView = useSelector((store) => store.app.kioskView);
  const toggleKioskView = (kioskView) => {
    dispatch(setKioskView(kioskView));

    // Save user's preference to sessionStorage so it persists across navigation
    // This only happens when in kiosk mode (kioskMode is true)
    if (kioskMode) {
      sessionStorage.setItem(
        'cinch-kiosk-view-preference',
        kioskView.toString(),
      );
    }
  };

  const enableAccountChek = kioskMode;
  const enableTheWorkNumber = kioskMode;
  const enableRunDisclosures = kioskMode;

  return {
    kioskMode,
    kioskView,
    toggleKioskView,
    enableAccountChek,
    enableTheWorkNumber,
    enableRunDisclosures,
  };
};
